import React from 'react';
import { FiCpu } from 'react-icons/fi';
import ServiceTemplate from './ServiceTemplate';

export default function AIAutomationService() {
  return (
    <ServiceTemplate
      slug="ai-automation"
      color="#0052cc"
      icon={<FiCpu size={40} />}
      title="AI & Automation Consulting"
      tagline="Deploy intelligent automation that eliminates manual work and scales with your business."
      heroDescription="We design, build, and deploy custom AI systems — from LLM-powered agents that replace legacy automation tools to internal copilots that supercharge your team's productivity. Our engineers have shipped 40+ production AI systems across every major industry."
      features={[
        { title: 'Custom AI Agent Development', description: 'Purpose-built agents that handle multi-step workflows autonomously — from data extraction to decision-making to action execution.' },
        { title: 'LLM Integration & Fine-Tuning', description: 'Integrate GPT-4, Claude, Gemini, Llama, or Mistral into your products. We handle prompt engineering, fine-tuning, RAG pipelines, and evaluation.' },
        { title: 'Workflow Automation', description: 'Replace brittle Zapier/Make automations with intelligent AI-driven workflows that adapt, retry, and handle edge cases.' },
        { title: 'Internal Copilots', description: 'Deploy custom AI assistants trained on your data — for support teams, engineering, sales, operations, or any role.' },
        { title: 'Document Intelligence', description: 'OCR, extraction, classification, and summarization systems for contracts, invoices, reports, medical records, and more.' },
        { title: 'Conversational AI', description: 'Production chatbots and voice agents with multi-turn memory, tool use, and integration with your CRM and ticketing systems.' },
      ]}
      useCases={[
        { title: 'Enterprise Workflow Replacement', description: 'A Series B SaaS company replaced their entire Zapier stack with custom AI agents.', result: '74% reduction in workflow setup time, 99.7% uptime' },
        { title: 'Legal Document Processing', description: 'Built a RAG-powered document intelligence system processing 50K+ docs/month.', result: '96.3% extraction accuracy, 10x throughput increase' },
        { title: 'Customer Support Copilot', description: 'Deployed an internal copilot for a fintech support team handling 3x ticket volume.', result: '35% productivity increase, 4-week delivery' },
      ]}
      techStack={[
        'OpenAI GPT-4', 'Anthropic Claude', 'Google Gemini', 'Meta Llama', 'Mistral',
        'LangChain', 'LlamaIndex', 'Pinecone', 'Weaviate', 'ChromaDB',
        'Python', 'Node.js', 'FastAPI', 'AWS Bedrock', 'Azure OpenAI',
        'Docker', 'Kubernetes', 'Terraform', 'PostgreSQL', 'Redis',
      ]}
    />
  );
}
